import { render, staticRenderFns } from "./FloatingClouds.vue?vue&type=template&id=5cf7d78f&scoped=true&"
import script from "./FloatingClouds.vue?vue&type=script&lang=js&"
export * from "./FloatingClouds.vue?vue&type=script&lang=js&"
import style0 from "./FloatingClouds.vue?vue&type=style&index=0&id=5cf7d78f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf7d78f",
  null
  
)

export default component.exports